
<template>
  <div>
    <v-select
      v-model="selected"
      :items="items"
      item-value="id"
      item-text="name"
      :loading="loading"
      :label="$t('countrySelect.label')"
      :clearable="clearable"
      :disabled="disabled"
      menu-props="auto"
      single-line
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "CountrySelect",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      required: false,
    },
  },
  data: function () {
    return {
      ownChangeEvent: false,
      loading: false,
      items: [],
      selected: null,
    };
  },
  computed: {},
  watch: {
    value: function (val) {
      if ((this.selected && !val) || (!this.selected && val)) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      if (this.selected && val && this.selected.place_id != val.place_id) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      // console.log('Ignoring new value')
    },
    selected: function () {
      if (!this.ownChangeEvent) {
        this.$emit("input", this.selected);
      }
    },
  },
  mounted() {
    this.ownChangeEvent = true;
    this.selected = this.value;
    this.ownChangeEvent = false;
    this.refreshData();
  },
  methods: {
    refreshData: function() {
      this.loading = true;
      this.$api.getCountries().then((res) => {
        this.loading = false;
        this.items = res.data;
      })
      .catch(error => {
          this.loading = false;
          this.$common.onError(error)
      })
    }
  },
};
</script>